









import { Component, Vue } from 'vue-property-decorator'
import AppLayout from './components/layout/AppLayout.vue'
import { routes } from '@/routes/index.ts'
import SidePanel from './components/layout/SidePanel.vue'
import VueRouter from 'vue-router'


const router = new VueRouter({
    routes
})
const DEFAULT_TITLE = 'Internal Tools'
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.updateTitle && to.path !== '/') {
        document.title = `${to.meta.title} | ${DEFAULT_TITLE}`
    } else {
        document.title = DEFAULT_TITLE
    }
    next()
})


@Component({
    router,
    components: {
        AppLayout,
        SidePanel
    }
})
export default class App extends Vue {}
